<template lang="pug">
div.box
    v-server-table(
        :url="datatableUrl",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
        template(slot="beforeTable")
            datatable-loader(:name="tableName")
</template>

<script>
import { mapState } from 'vuex';
import numeral from 'numeral';

export default {
    data() {
        var that = this;

        return {
            tableName: 'TRANSACTION_BREAKDOWN',
            columns: [
                'receipt_date',
                'total',
                'total_cash',
                'total_credit_card',
                this.trans('general.total_setel'),
                'total_voucher',
                'total_others',
            ],
            options: {
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                useReportFilter: true,
                columnsDropdown: true,
                filterable: false,
                perPage: 2000,
                perPageValues: [2000],
                texts: {
                    title: this.trans('report.transaction_breakdown'),
                    description:
                        'Shows transaction breakdown by payment method',
                },
                pdf_url: Laroute.route(
                    'franchise.report.transaction.breakdown_export',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.transaction.breakdown_export',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.transaction.breakdown_export',
                    { type: 'XLSX' },
                ),
                headings: {
                    receipt_date: 'Receipt Date',
                    total_cash: this.trans('report.total_cash'),
                    total_credit_card: this.trans('report.total_credit_card'),
                    total_voucher: this.trans('report.total_voucher'),
                    total_others: this.trans('report.total_others'),
                    total_setel: 'Setel',
                    total_cheque: 'Total Cheque',
                },
                responseAdapter: res => {
                    const data = res.data.data.map(data => {
                        let total_setel = this.trans('total_setel');

                        return {
                            receipt_date: moment(data.receipt_date)
                                .format('dddd, DD MMM YYYY')
                                .toUpperCase(),
                            total: this.numberFormat(data.total),
                            total_cash: this.numberFormat(data.total_cash),
                            total_credit_card: this.numberFormat(
                                data.total_credit_card,
                            ),
                            [total_setel]: this.numberFormat(data[total_setel]),
                            total_voucher: this.numberFormat(
                                data.total_voucher,
                            ),
                            total_others: this.numberFormat(data.total_others),
                        };
                    });

                    return {
                        data,
                        count: res.data.count,
                    };
                },
                columnsClasses: {
                    total: 'text-right',
                    total_cash: 'text-right',
                    total_credit_card: 'text-right',
                    [this.trans('general.total_setel')]: 'text-right',
                    total_voucher: 'text-right',
                    total_others: 'text-right',
                },
            },
        };
    },

    computed: {
        ...mapState('tillFilter', ['filters']),

        datatableUrl() {
            return Laroute.route('franchise.report.transaction.breakdown');
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },
    },

    created() {
        this.removeLimitState();
        this.setHeadings();
        window.addEventListener('beforeunload', this.removeLimitState);
    },

    methods: {
        numberFormat(total) {
            return numeral(total).format('0,0.00');
        },

        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },

        removeLimitState() {
            let query = JSON.parse(
                localStorage.getItem(`vuetables_${this.tableName}`),
            );

            if (!_.isNull(query) && !_.isUndefined(query.perPage)) {
                query.perPage = 2000;

                localStorage.setItem(
                    `vuetables_${this.tableName}`,
                    JSON.stringify(query),
                );
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/transaction/transaction-breakdown.vue